/**
 * One labeled row of a publisher campaign config. Lives in its own module so the
 * Campaign Manager tab and the per-publisher sections it renders share a single
 * current-versus-draft presentation: a changed current value is struck through
 * and the draft value shows in blue beside it.
 */
import React from 'react';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

interface ConfigFieldProps {
  label: string;
  current: string;
  draft?: string;
  showDraft: boolean;
}

export const ConfigField: React.FC<ConfigFieldProps> = ({ label, current, draft, showDraft }) => {
  const changed = showDraft && draft !== undefined && draft !== current;
  const newField = showDraft && !current && draft;
  const sameDraftValue = showDraft && draft !== undefined && draft === current;
  return (
    <Row spacing="200" widths={['240px', 'fill']}>
      <Text color="secondary" type="b300">{label}</Text>
      <span style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', gap: '4px' }}>
        {current && changed && (
          <Text color="secondary" type="b200">
            <span style={{ textDecoration: 'line-through' }}>{current}</span>
          </Text>
        )}
        {(current && !changed) && (
          <Text color={sameDraftValue ? 'secondary' : undefined} type="b300">{current}</Text>
        )}
        {(changed || newField) && (
          <Text type="b300">
            <span style={{ color: '#066098' }}>{draft}</span>
          </Text>
        )}
      </span>
    </Row>
  );
};
